import React from 'react';
import { useSelector } from 'react-redux';

import { ModalTypes } from './instances';
import { getModalType } from './selectors';
// Import modal components
import JobShareModal from '../../pages/jobs/container/jobShareModal';
import AiAssistantModal from '../../pages/jobs/container/aIAssistantModal';

// Map modal types to their components
const modals = {
  [ModalTypes.jobShareModal]: JobShareModal,
  [ModalTypes.aiAssistantModal]: AiAssistantModal,
  // Add other modal components here as they are created
};

const RootModal: React.FC = () => {
  const modalType = useSelector(getModalType);
  const Component = modalType && modals[modalType];

  if (!Component) return null;

  return <Component />;
};

export default RootModal; 